export type StaticMetadata = {
  icon: any[] | undefined
  apple: any[] | undefined
  openGraph: any[] | undefined
  twitter: any[] | undefined
  manifest: string | undefined
} | null
